import React from "react";
import { TextField } from "cayo.ui";
import styled from "styled-components";
import { useIntl } from "react-intl";
import { communicationChannelsWizardMessages } from "../messages";

type ChannelNameProps = {
  name: string;
  description: string;
  handleChange: (key: string, value: string) => void;
};

export const ChannelName = ({ name, description, handleChange }: ChannelNameProps) => {
  const intl = useIntl();

  return (
    <div>
      <TextField
        label={intl.formatMessage(communicationChannelsWizardMessages.channelNameField)}
        required
        value={name}
        setValue={(value) => handleChange("name", value)}
      />

      <TextareaWrap>
        <TextField
          label={intl.formatMessage(communicationChannelsWizardMessages.channelNameDesc)}
          multiline
          rows={5}
          value={description}
          setValue={(value) => handleChange("description", value)}
        />
      </TextareaWrap>
    </div>
  );
};

const TextareaWrap = styled.div`
  margin-top: 10px;
`;
